module.exports = __webpack_public_path__ + "frontend-assets/img/history_icon-hover.9780d023.png";